export default "__VITE_ASSET__CQP2FL_h__"